import { render, staticRenderFns } from "./CustomerInfo.vue?vue&type=template&id=405745e0&scoped=true&"
import script from "./CustomerInfo.vue?vue&type=script&lang=js&"
export * from "./CustomerInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "405745e0",
  null
  
)

export default component.exports